import React, { useState, useEffect } from "react";

function VariantOption({ type, variants, selectedIndex, selectedValue, onVariantClick }) {
  const parseColorTitle = (title) => {
    if (!title) return { colorName: "", colorCode: "" };
    const [colorName, colorCode] = title.split(/\s*\|\|\s*/);
    return { colorName, colorCode: colorCode || colorName };
  };  

  return (
    <>
      {variants.length > 0 && (
        <>
          <div className={`${type.toLowerCase().replace(/\s+/g, '-')}-title`}>
            <h4>{type}</h4>
            {type.toLowerCase() === "color" && selectedValue && (
              <span className="selected-color-name">
                : {parseColorTitle(selectedValue.value).colorName}
              </span>
            )}
          </div>
          <div className={`${type.toLowerCase().replace(/\s+/g, '-')}-group`}>
            {variants.map((variant, index) => {
              const isColorVariant = type.toLowerCase() === "color";
              const { colorName, colorCode } = isColorVariant 
                ? parseColorTitle(variant.value)
                : { colorName: "", colorCode: "" };

              return (
                <div
                  key={index}
                  style={{ position: "relative" }}
                  onClick={() => onVariantClick(type, index, variant)}
                  className={`${type.toLowerCase().replace(/\s+/g, '-')}-item mb-2 ${
                    selectedIndex === index ? "active" : ""
                  }`}
                >
                  <input
                    type="radio"
                    style={{
                      position: "absolute",
                      height: "100%",
                      width: "100%",
                      top: "0px",
                      left: "0px",
                      display: "none",
                    }}
                    name={type.toLowerCase().replace(/\s+/g, '-')}
                    value={variant.value}
                    checked={selectedIndex === index}
                    readOnly
                  />
                  {isColorVariant ? (
                    <div className="color-variant">
                      <div
                        className="color-box"
                        style={{
                          backgroundColor: colorCode,
                          width: "20px",
                          height: "20px",
                          borderRadius: "50%",
                          marginTop: "5px",
                        }}
                      />
                    </div>
                  ) : (
                    variant.value
                  )}
                </div>
              );
            })}
          </div>
        </>
      )}
    </>
  );
}

function VariantList({ productVariants, onVariantSelect }) {
  const [selectedVariantIndexes, setSelectedVariantIndexes] = useState({});
  const [selectedVariantValues, setSelectedVariantValues] = useState({});
  const [uniqueVariants, setUniqueVariants] = useState({});
  const [hasChanged, setHasChanged] = useState(false);

  const getUniqueVariants = (filteredVariants) => {
    const variantTypes = {};

    console.log(filteredVariants,'fv')
    filteredVariants.forEach((variant) => {
      variant.variants.forEach(({ title: type, value }) => {
        const { title: valueTitle, _id: valueId } = value;
        const id = valueId || valueTitle;

        if (!variantTypes[type]) {
          variantTypes[type] = [];
        }
        if (!variantTypes[type].some((v) => v.id === id)) {
          variantTypes[type].push({
            id,
            value: valueTitle,
            stock: variant.stock,
            mrp: variant.mrp,
            price: variant.price,
          });
        }
      });
    });

    return variantTypes;
  };

  useEffect(() => {
    // Filter out disabled variants
    const filteredVariants = productVariants?.filter(variant => !variant.isDisabled) || [];
    const variants = getUniqueVariants(filteredVariants);
    setUniqueVariants(variants);
  
    const initialSelected = {};
    const initialValues = {};
  
    // Find the first variant with stock > 0
    let firstAvailableVariant = filteredVariants.find(variant => variant.stock > 0);
  
    if (!firstAvailableVariant) {
      // If no variant has stock > 0, fallback to the first variant
      firstAvailableVariant = filteredVariants[0];
    }
  
    Object.keys(variants).forEach((type) => {
      if (variants[type].length > 0) {
        const selectedVariant = firstAvailableVariant.variants.find(v => v.title === type);
        const selectedIndex = variants[type].findIndex(v => v.id === selectedVariant?.value._id);
  
        initialSelected[type] = selectedIndex !== -1 ? selectedIndex : 0;
        initialValues[type] = variants[type][initialSelected[type]];
      }
    });
  
    // Determine price and mrp based on initialValues
    const matchedVariant = filteredVariants.find((variant) =>
      variant.variants.every((v) => initialValues[v.title]?.id === v.value._id)
    );
  
    if (matchedVariant) {
      initialValues.price = matchedVariant.price;
      initialValues.mrp = matchedVariant.mrp;
    }
  
    setSelectedVariantIndexes(initialSelected);
    setSelectedVariantValues(initialValues);
    onVariantSelect(initialValues);
  }, [productVariants]);

  const handleVariantClick = (type, index, value) => {
    setHasChanged(true);

    setSelectedVariantIndexes((prev) => ({
      ...prev,
      [type]: index,
    }));

    const updatedValues = {
      ...selectedVariantValues,
      [type]: value,
    };

    const matchedVariant = productVariants.find((variant) =>
      variant.variants.every((v) => updatedValues[v.title]?.id === v.value._id)
    );

    if (matchedVariant) {
      updatedValues.mrp = matchedVariant?.mrp;
      updatedValues.price = matchedVariant?.price;
    }

    setSelectedVariantValues(updatedValues);
    onVariantSelect(updatedValues);

    if (value.stock !== undefined) {
      localStorage.setItem("selectedStock", value.stock);
    }
  };

  useEffect(() => {
    if (!hasChanged) {
      onVariantSelect(selectedVariantValues);
    }
  }, [hasChanged, selectedVariantValues, onVariantSelect]);

  useEffect(() => {
    if (!productVariants || productVariants.length === 0) {
      setUniqueVariants({});
      setSelectedVariantIndexes({});
      setSelectedVariantValues({});
    }
  }, [productVariants]);

  return (
    <div className="additional-details">
      {Object.keys(uniqueVariants).map((type) => (
        <VariantOption
          key={type}
          type={type}
          variants={uniqueVariants[type]}
          selectedIndex={selectedVariantIndexes[type]}
          selectedValue={selectedVariantValues[type]}
          onVariantClick={handleVariantClick}
        />
      ))}

      {/* {Object.keys(uniqueVariants).length === 0
      
      && 
      
      (
        <div className="no-variants">No variants available</div>
      )} */}
    </div>
  );
}

export default React.memo(VariantList);